import { ScheduleMeetingData, CalendarEventResponse } from "../../common/store/theme/types/schedule-meeting";
export const scheduleMeeting = async (
  data: ScheduleMeetingData
): Promise<CalendarEventResponse> => {
  try {
    const response = await fetch(`${process.env.API_URL}/create-calendar-event`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to schedule meeting: ${errorText}`);
    }

    const result: CalendarEventResponse = await response.json();
    return result;
  } catch (error) {
    console.error("Error scheduling meeting:", error);
    throw error;
  }
};
